import React from 'react';
import {Container} from 'react-bootstrap';
import {HomeEventItem} from "./HomeEventItem";
import {HomeSectionTitle, HomeSectionType} from "../../utils/common-styles";

export const HomeEventsList = (props) => {

    return (
        <>
            <HomeSectionTitle><strong>Our Next   ____</strong></HomeSectionTitle>
            <HomeSectionType><h2>Events</h2></HomeSectionType>
            <Container>
            {props.posts.length > 0 && props.posts.map((eventItem) => {
                return <HomeEventItem key={eventItem.id} eventItem={eventItem} />
            })}
            </Container>
        </>
    );
};
